// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodProjectId } from './FoodProject';
import { fileStorageId } from './FileStorage';
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodTastingImageSourceId = (z.number());
export const foodTastingImageSource = z.object({
    id: foodTastingImageSourceId,
    project_id: foodProjectId,
    file_storage_id: fileStorageId,
    in_use: z.boolean(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const foodTastingImageSourceInitializer = z.object({
    id: foodTastingImageSourceId.optional(),
    project_id: foodProjectId,
    file_storage_id: fileStorageId,
    in_use: z.boolean().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const foodTastingImageSourceMutator = z.object({
    id: foodTastingImageSourceId.optional(),
    project_id: foodProjectId.optional(),
    file_storage_id: fileStorageId.optional(),
    in_use: z.boolean().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodTastingImageSource.js.map